import { motion } from "framer-motion";
import { User } from "lucide-react";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ArthereumIcon from "../../WebAppsSharedStuffs/components/ArtheumIcon";
import { PAGE_NAME, UserModelData } from "../../types";

/** Top bar: brand, ATH balance (→ Shop), avatar (→ Profile). */
const MobileTopNav: React.FC = () => {
  const userData: UserModelData = useSelector(
    (state) => (state as any)?.actualUser
  );

  return (
    <motion.div
      className="md:hidden w-full fixed top-0 left-0 right-0 h-16 bg-white/90 backdrop-blur-md shadow-sm z-50 flex items-center px-3 gap-2.5 border-b border-gray-100"
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 300, damping: 30, opacity: { duration: 0.2 } }}
    >
      <Link to={PAGE_NAME.HOME} className="flex items-center gap-2 flex-shrink-0">
        <div className="w-9 h-9 rounded-xl bg-indigo-600 flex items-center justify-center">
          <ArthereumIcon className="w-5 h-5 text-white" />
        </div>
        <span className="font-black text-gray-900 text-sm tracking-tight">Arthereum</span>
      </Link>

      <div className="flex-1 flex justify-end">
        <Link to={PAGE_NAME.SHOP} className="flex-shrink-0">
          <motion.div
            className="flex items-center gap-1.5 bg-orange-50 hover:bg-orange-100 rounded-xl px-2.5 py-1.5 border border-orange-200 transition-colors"
            whileTap={{ scale: 0.95 }}
          >
            <ArthereumIcon className="w-4 h-4 text-orange-500" />
            <span className="font-semibold text-orange-800 text-xs whitespace-nowrap">
              {(userData?.user?.arthereumBalance ?? 0).toFixed(2)} ATH
            </span>
          </motion.div>
        </Link>
      </div>

      <Link to={PAGE_NAME.PROFILE} className="flex-shrink-0">
        <motion.div className="relative" whileTap={{ scale: 0.95 }}>
          {userData?.user?.profileImage ? (
            <div className="w-10 h-10 rounded-xl overflow-hidden border border-gray-200">
              <img src={userData.user.profileImage} alt="Profile" className="w-full h-full object-cover" />
            </div>
          ) : (
            <div className="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center border border-gray-200">
              <User className="w-5 h-5 text-gray-500" strokeWidth={2} />
            </div>
          )}
        </motion.div>
      </Link>
    </motion.div>
  );
};

export default MobileTopNav;
